// extracted by mini-css-extract-plugin
export default {"ldsRing":"Spinner_ldsRing__H-YzZ"};